export default "__VITE_ASSET__DTIOR8hf__"